export default "__VITE_ASSET__iqbtTcrK__"